module.exports = __webpack_public_path__ + "media/images/emp/sort_asc-9326ad44ae4bebdedd141e7a53c2a730.png";